import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import { Metrics, Fonts, Colors } from '../../Themes'
import Modal from './index'
import Button from '../../components/Button'

const CustomButton = styled(Button)`
  margin-top: ${Metrics.margins.base};
  ${props =>
    props.left ? `margin-left: ${Metrics.margins.small}` : 'margin-left: 0'};
  ${props =>
    props.right ? `margin-right: ${Metrics.margins.small}` : 'margin-right: 0'};
`

const Header = styled.div`
  ${Fonts.style.Header};
  color: ${Colors.primary};
`

class DialogModal extends Component {
  shouldComponentUpdate (nextProps) {
    const { visible } = this.props
    return visible !== nextProps.visible
  }

  render () {
    const { visible, closeAction, header, message, buttons } = this.props
    return (
      <Modal
        header={<Header>{header}</Header>}
        visible={visible}
        closeAction={closeAction}>
        <div>{message}</div>
        <CustomButton
          right
          onClick={buttons.cancel.onClick}
          label={buttons.cancel.label}
        />
        <CustomButton
          left
          onClick={buttons.apply.onClick}
          label={buttons.apply.label}
        />
      </Modal>
    )
  }
}

DialogModal.propTypes = {
  visible: PropTypes.bool,
  message: PropTypes.node,
  closeAction: PropTypes.func,
  backAction: PropTypes.func,
  header: PropTypes.node,
  buttons: PropTypes.object.isRequired
}

export default DialogModal



// WEBPACK FOOTER //
// ./src/components/Modal/DialogModal.js